<template>
  <div :class="title != null ? 'bg-white border rounded shadow-sm':''">
    <div v-if="title != null" class="font-semibold mx-2 my-3 text-gray-600">{{ title }}</div>
    <div v-if="newPlan" class="block">
      <div class="flex w-full h-64 py-5 items-center justify-center bg-grey-lighter">
        <label v-if="!showHeatMap && $store.getters.can('edit_network_layout')" class="w-64 flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg tracking-wide
         uppercase border border-blue cursor-pointer hover:bg-blue hover:text-teal-500">
          <feather type="upload" class="fill-current h-6 w-6 mr-4"/>
          <span class="mt-2 text-base leading-normal">Upload layout plan</span>
          <input type='file' ref="file" v-on:change="handleFileUpload()" class="hidden"/>
        </label>
        <div v-else>
          No layout plan
        </div>
      </div>
    </div>
    <div class="h-75 " v-else>
      <div class="w-full  " ref="konvaStage">
        <v-stage :config="{width: width,height: height}">
          <v-layer>
            <v-image :config="{draggable:false, width: width,height: height,image: image}"/>
            <v-group @dragend="mapAp($event, ap.id)" :config="{draggable:true, stroke: 'black'}"
                     v-for="ap in accessPoints" v-bind:key="ap.id">
              <v-circle :config="{x: ap.x, y: ap.y, fill:'red',radius: 5 }"/>
              <v-text
                  :config="{text: ap.name, x: ap.x- 30,y : ap.y + 10, fontStyle:'bold',fill: 'red', stroke: 'transparent'}"/>
            </v-group>
          </v-layer>
        </v-stage>
      </div>
      <div class="w-full mt-2">
        <div style="cursor: pointer" v-on:click="newPlan = !newPlan"
             v-if="!showHeatMap && $store.getters.can('edit_network_layout')" class="text-blue-500">
          Change layout plan
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import h337 from 'heatmap.js';
import GraphQl from "@/services/graphql.service";

export default {
  name: "LayoutDesigner",
  props: {
    title: String,
    venueId: String,
    startDate: String,
    endDate: String,
    showHeatMap: {type: Boolean, default: false},
    height: {type: Number, default: 700},
  },
  data() {
    return {
      newPlan: false,
      loading: true,
      venue: Object,
      heatmapInstance: Object,
      accessPoints: [],
      image: null,
      logoImage: null,
      width: 1310,
      maxValue: 0
    };
  },
  computed: {},
  mounted() {
    this.getVenue();
    // this.width = this.$refs.konvaStage.clientWidth;
    // this.height = this.$refs.konvaStage.clientHeight;
    if (this.showHeatMap)
      this.heatmapInstance = h337.create({
        container: this.$refs.konvaStage,
        radius: 100
      })
  },
  watch: {
    venueId: function () {
      this.getVenue()
    }
  },
  methods: {
    handleFileUpload() {
      let formData = new FormData();
      formData.append('file', this.$refs.file.files[0]);
      formData.append("organization_id", this.$store.getters.orgId);
      formData.append("name", this.venueId + "_floor_plan");
      this.axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/assets', formData, {headers: {'Content-Type': 'multipart/form-data'}})
          .then((response) => {
            this.updateVenue(response.data.data.file.url);
          });
    },

    updateVenue(layout_image) {
      let params = {
        map_zoom: this.zoom,
        name: this.venue.name,
        organization_id: this.$store.getters.orgId,
        layout_image: layout_image
      };
      this.axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/venues/' + this.venueId, params)
          .then(() => {
            this.getVenue()
          }).catch(() => {
      });
    },

    generateHeatMaps() {
// heatmap data format
      console.log(this.maxValue)
      this.heatmapInstance.setData({
        max: this.maxValue,
        data: this.accessPoints
      });
    },
    getVenue() {
      this.accessPoints = [];
      let params = (this.startDate != null ? 'startDate: "' + this.startDate + '", ' : '') +
          (this.endDate != null ? 'endDate: "' + this.endDate + '", ' : '');
      GraphQl.sendRequest('{venue(id:"' + this.venueId + '") {name id layout_image ' +
          'accessPoints' + (params !== '' ? '(' + params + ')' : '') + '{name id lat lng capsUsersCount connectionsCount}}}')
          .then(response => {
            this.venue = response.venue;
            this.venue.accessPoints.forEach((ap, index) => {
              let value = ap.capsUsersCount || ap.connectionsCount || 0;
              if (value > this.maxValue) {
                this.maxValue = value;
              }
              this.accessPoints.push({
                id: ap.id, name: ap.name,
                x: ap.lat || (30 + (index * 10)),
                y: ap.lng || (10 + (index * 10)),
                value: value
              });
            });
            this.newPlan = this.venue.layout_image == null || this.venue.layout_image === '';
          })
          .finally(() => {
            this.loadFloorPlan()
            if (this.showHeatMap) this.generateHeatMaps()
            this.loading = false

          })
    },
    mapAp(event, id) {
      let params = {
        lat: event.evt.layerX,
        lng: event.evt.layerY
      };
      this.axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/access_points/map/' + id, params)
          .then(() => {
          }).catch(() => {
      });
    },
    loadFloorPlan() {
      const image = new window.Image();
      image.src = this.venue.layout_image;
      image.onload = () => {
        this.image = image;
      };

      const logoImage = new window.Image();
      logoImage.src = "http://localhost:8080/img/logo.cf9706f0.png";
      logoImage.onload = () => {
        // set image only when it is loaded
        this.logoImage = logoImage;
      };
    }
  },

}
</script>

<style scoped>

</style>